export const appElement = 'afLoginWidget';
